import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { connect } from 'react-redux'
import { mapProps, compose } from 'recompose'
import T from 'i18n-react'

import Dialog from 'react-toolbox/lib/dialog';
import { Checkbox } from 'react-toolbox/lib/checkbox';
import ReactToolboxInput from 'react-toolbox/lib/input';
// import { ListDivider } from 'react-toolbox/lib/list';

import Fields from '../SearchFieldsCard/Fields'; 

import {
  onSaveView,
  onCancelClick,
  onDialogClear,
  onUpdateViewName,
  togglePublicView,
  onSelectTempCustomView,
  onSelectTempSearchFilter,
  onRemoveTempSearchFilter,
  onSelectTempProductFilter,
  onRemoveTempProductFilter,
  deleteCustomView
} from 'containers/Project/ElasticSearch/actions'

import {
  activeStateSelector,
  displayFiltersStateSelector,
  viewLabelStateSelector,
  publicViewStateSelector,
  productHierarchyUiStateSelector,
  customViewsSelector,
  selectedTempCustomViewSelector,
  tempSelector,
  tempProductFiltersSelector
} from 'containers/Project/ElasticSearch/selectors'
import Divider from './Divider'
import List from './List'

import { GLOBAL_ROLES } from 'containers/Role/constants'
import showOnAnyRoles from 'containers/Role/Show/AnyGlobalRoles'

import styles from './styles.scss'

const showToTeam = compose(
  mapProps((props) => ({
    ...props,
    roles: [
      GLOBAL_ROLES.ADMIN_ACCESS
    ]
  })),
  showOnAnyRoles
)

const RestrictedCheckbox = showToTeam(Checkbox)

const mapStateToProps = (state) => {
  return {
    active: activeStateSelector(state),
    viewLabel: viewLabelStateSelector(state),
    publicView: publicViewStateSelector(state),
    customViews: customViewsSelector(state),
    selectedView: selectedTempCustomViewSelector(state),
    ts: tempSelector(state),
    productList: tempProductFiltersSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSave: () => dispatch(onSaveView()),
    togglePublicView: () => dispatch(togglePublicView()),
    updateViewName: (val) => dispatch(onUpdateViewName(val)),
    onCancel: () => dispatch(onCancelClick()),
    onClear: () => dispatch(onDialogClear()),
    onSelectCustomView: (val) => dispatch(onSelectTempCustomView(val)),
    onTempSelect: (val) => dispatch(onSelectTempSearchFilter(val)),
    onTempRemove: (val) => dispatch(onRemoveTempSearchFilter(val)),
    onTempProductSelect: (val) => dispatch(onSelectTempProductFilter(val)),
    onTempProductRemove: (val) => dispatch(onRemoveTempProductFilter(val)),
    deleteCustomView: () => dispatch(deleteCustomView())
  }
}

const FieldDialog = props => {
  const {
    active,
    onCancel,
    onSave,
    togglePublicView,
    publicView,
    ts,
    productList,
    onTempSelect,
    onTempRemove,
    onTempProductSelect,
    onTempProductRemove,
    updateViewName,
    viewLabel
  } = props

  let other = []

  return (
    <Dialog
      actions={[
        { label: "Cancel", onClick: onCancel },
        { label: "Save", onClick: onSave },
      ]}
      active={active}
      onOverlayClick={onCancel}
      onEscKeyDown={onCancel}
      title={T.translate('containers.project.search.customFilter.title')}
      styleName='dialogContainer'
      theme={styles}
    >
      <div styleName="parentContainer">

        <div styleName="leftContainer">
          <div styleName="dialogSection">
            <RestrictedCheckbox
              checked={publicView}
              onChange={togglePublicView}
              label="Make view public"
              styleName="publicViewCheckbox"
              theme={styles}
            />
            <ReactToolboxInput
              label="Custom View Name"
              defaultValue={viewLabel}
              onBlur={(e) => updateViewName(e.currentTarget.value)}
              styleName='viewNameInput'
              theme={styles}
            />
          </div>
        </div>

        <div styleName="rightContainer">
          <div styleName="dialogSection">
            <h4>Selected Search Filters</h4>
            <Fields
              list={ts}
              onClick={(checked, value) => {
                checked ? onTempSelect(value) : onTempRemove(value)
              }}
              notCollapseable={true}
              theme={styles}
            />
            <br />
            <h4>Selected Product Filters</h4>
            <Fields 
              list={productList}
              onClick={(checked, value) => {
                checked ? onTempProductSelect(value) : onTempProductRemove(value)
              }}
              notCollapseable={true}
            />
          </div>

        </div>

      </div>
      
    </Dialog>
  )
}

FieldDialog.propTypes = {
  active: PropTypes.bool.isRequired,
  filters: PropTypes.object.isRequired,
  search: PropTypes.string.isRequired,
  quickFilters: PropTypes.array.isRequired
}

FieldDialog.defaultProps = {
  active: false,
  filters: {},
  search: '',
  quickFilters: []
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
  withConnect,
  withStyle,
)

export default enhance(FieldDialog)
